<template>
  <EasyMenu
    v-model="isVisible"
    :activator="props.activator"
    open-on-hover
    :close-on-content-click="false"
    :location="Anchor.Top"
    class="persistent-tooltip"
  >
    <div
      class="persistent-tooltip__wrapper"
      data-cy="wrapper__easy-persistent-tooltip"
    >
      <div
        v-for="(paragraph, i) in normalizedContent"
        :key="i"
        class="persistent-tooltip__content"
      >
        <span
          v-dompurify-html="paragraph"
          data-cy="text__easy-persistent-tooltip"
          :class="{
            [`persistent-tooltip__content--clamped-${props.clampedRows}`]: applyTextClamp(i),
          }"
        />
        <div
          v-if="applyTextClamp(i)"
          class="persistent-tooltip__content--more-btn"
          data-cy="button-more__easy-persistent-tooltip"
          @click="expandParagraph(i)"
        >
          {{ t("button_read_more") }}
        </div>
      </div>
    </div>
  </EasyMenu>
</template>

<script setup lang="ts">
import { ref, reactive, watch, computed } from "vue";
import { forEach, set, isArray, get } from "lodash";
import { LOCALIZATION_KEYS } from "@/src/easy-ui/constants/easyPersistentTooltip";
import EasyMenu from "@/src/easy-ui/components/EasyMenu.vue";
import { Anchor } from "@/src/easy-ui/types/easyMenu";

window.EasyLocale.fetchLocales(LOCALIZATION_KEYS);

const t = window.EasyLocale.getLocale;

interface Props {
  clampedRows?: number;
  content: string | string[];
  activator: HTMLElement;
}

const props = defineProps<Props>();

const isVisible = ref<boolean>(false);

const expandedParagraphs = reactive<Record<number, boolean>>({});

const normalizedContent = computed<string[]>(() => {
  return isArray(props.content) ? props.content : [props.content];
});

const applyTextClamp = (i: number) => {
  return !get(expandedParagraphs, i, false) && props.clampedRows;
};

const expandParagraph = (index: number): void => {
  set(expandedParagraphs, index, true);
};

const resetExpanded = (): void => {
  forEach(normalizedContent.value, (_, index) => {
    set(expandedParagraphs, index, false);
  });
};

watch(isVisible, () => resetExpanded());
</script>
